export default function NotificationBubble({ count, className = '' }) {
  if (count === 0) {
    return null;
  }

  const classNameList = `roundImageNotification__count ${className}`;
  return <span className={classNameList}>{count > 99 ? '99+' : count}</span>;
}
